import {BaseModel} from './base.model';
import {INotification} from './database';
import moment from 'moment';
import {alert, defaultModules, Notice, Stack} from '@pnotify/core';
import * as PNotifyDesktop from '@pnotify/desktop';

const modules = new Map([
  ...defaultModules,
  /*  [PNotifyDesktop, {
      title: 'Alerts',
    }]*/
]);

const notificationStack = new Stack({
  dir1: 'up',
  dir2: 'left',
  firstpos1: 15,
  firstpos2: 15,
  modal: false,
  maxOpen: 2,
});

export interface NotificationProperties {
  type: 'notice' | 'info' | 'success' | 'error';
  title?: string;
  text: string;
}

export const TRAILER_INTERVENTION_OVER_SPEED_NOTIFICATION = 'TRAILER_INTERVENTION_OVER_SPEED';
export const TRAILER_INTERVENTION_UNDER_SPEED_NOTIFICATION = 'TRAILER_INTERVENTION_UNDER_SPEED';

const notifications = new Map<string, NotificationProperties>([
  [TRAILER_INTERVENTION_OVER_SPEED_NOTIFICATION, {
    type: 'notice',
    title: 'Excès de vitesse',
    text: 'Excès de vitesse #tractorName# #speed# km/h',
  }],
  [TRAILER_INTERVENTION_UNDER_SPEED_NOTIFICATION, {
    type: 'notice',
    title: 'Abaissement de vitesse',
    text: 'Abaissement de vitesse #tractorName# #speed# km/h',
  }],
]);

export class Notification extends BaseModel<INotification> implements INotification {
  id: number;
  time: Date;
  type: string;
  variables: any;
  message: string;
  ago: string;
  properties: NotificationProperties;


  constructor(data: INotification) {
    super(data);
    this.properties = notifications.get(this.type);
    const diff = moment(this.time).diff(moment().utc());
    this.ago = moment.duration(diff).humanize(true);

    this.message = this.properties.text;
    if (!this.message) {
      return;
    }

    Object.keys(this.variables).forEach(key => {
      this.message = this.message.replace(`#${key}#`, this.variables[key]);
    });
  }

  public show(click?: (notice: Notice) => void) {
    const a = alert({
      type: this.properties.type,
      // title: this.properties.title,
      text: this.message,
      mode: 'light',
      stack: notificationStack,
      modules,
    });

    if (click) {
      a.refs.elem.style.cursor = 'pointer';
      a.on('click', e => {
        // @ts-ignore
        if ([...a.refs.elem.querySelectorAll('.pnotify-closer *, .pnotify-sticker *')].indexOf(e.target) !== -1) {
          return;
        }
        click(a);
      });
    }
  }

}
